
// Plugin dependencies
import router from "@/app/router/router";
import auth from "@/api/auth/auth";
import notification from "@/utils/plugins/NotificationService";

// Default Messages
const defaultMessage = 'Se ha producido un error en nuestro sistema, por favor inténtelo de nuevo más tarde o contacte con nuestro servicio técnico.'
const notFoundMessage = 'No se ha encontrado el registro que buscabas, o no había resultados en la búsqueda.'
const notPermissionsMessage = 'No dispones de los permisos requeridos para realizar esta acción.'
const badCredentialsMessage = 'Los datos introducidos para iniciar sesión son incorrectos o no coinciden con tu usuario y contraseña.'


// Errors shown in console
function getErrorsOnConsole(err) {
  console.groupCollapsed(
    '%c🐞',
    'color: #dc6a6a; border: 2px solid #dc6a6a; padding: 4px; border-radius: 4px;',
    'A wild server error has appeared: ')
  console.info(err.data.message ? err.data.message : err.data.error ? `${err.data.error}: ${err.data.error_description}` : defaultMessage)
  console.groupCollapsed('👾 Debugger')
  console.log(err)
  console.table({ err })
  console.groupEnd();
  console.groupEnd();
}

async function errorResponseHandler(error, message, mode) {
  if (mode === 'auth') {
   if(error.response && error.response.data.code === 401) {
     notification.addNotification(badCredentialsMessage, 'error', 6000)
    }
    getErrorsOnConsole(error.response);
    return;
  }
  if(error.response && error.response.status === 401) {
    await auth.logout({ preserveRedirect: true })
    return;
  }else if (error.response) {
    const err = error.response

    getErrorsOnConsole(err)

    // Notification errors
    const msg = message ? message : err.data.message ? err.data.message : err.data.detail ? err.data.detail : err.data.error ? `${err.data.error}: ${err.data.error_description}` : null
    if(err.status) {
      switch (err.status) {
        case 400:
          notification.addNotification(msg ? msg : defaultMessage, 'error', 6000)
          break
        case 401:
             await router.push({ name: 'login' })
          break
        case 403:
          notification.addNotification(msg ? msg : notPermissionsMessage, 'warning', 6000)
          break
        case 404:
          notification.addNotification(msg ? msg : notFoundMessage, 'warning', 6000)
          break
        case 500:
          notification.addNotification(msg ? msg : defaultMessage, 'error', 6000)
          break
        default:
          notification.addNotification(msg ? msg : defaultMessage, 'error', 6000)
      }
    } else {
      notification.addNotification(msg ? msg : defaultMessage, 'error', 6000)
    }
  } else {
    notification.addNotification(defaultMessage, 'error', 6000)
  }
}


export default errorResponseHandler;
